import avatar1 from 'assets/img/avatars/avatar1.png';
import avatar2 from 'assets/img/avatars/avatar2.png';
import avatar3 from 'assets/img/avatars/avatar3.png';

import Card from 'components/card';
import BuyerMyOfferCard from 'components/card/OfferCard';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { useNavigate } from 'react-router-dom';
import { getImage } from 'variables/images';
import SuccessModal from './components/SuccessModal';
import { useDisclosure } from '@chakra-ui/hooks';
import { ToastContainer, toast } from 'react-toastify';
import ErrorModal from './components/ErrorModal';

// Helper function to convert kebab-case back to proper capitalization
const convertToProperCase = (kebabCase: string): string => {
    if (!kebabCase) return '';
    return kebabCase
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const MyOffer = () => {
    const [offer, setOffer] = useState([]);
    const [purchaseOrders, setPurchaseOrders] = useState<any[]>([]);
    const [activeTab, setActiveTab] = useState<'offers' | 'purchase-orders'>('offers');
    const [loadingOrders, setLoadingOrders] = useState(true);
    const [user, setUser] = useState(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isOpen2,
        onOpen: onOpen2,
        onClose: onClose2,
    } = useDisclosure();
    const nav = useNavigate();

    const initOffer = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/offer/mine`, config)
            .then((res) => {
                const offers = res.data;
                setOffer(offers);
                console.log(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const initUser = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                const user = res.data;
                if (user.kyc_url) {
                    setTimeout(() => {
                        window.location.href = user.kyc_url;
                    }, 3000);
                }
                setUser(user);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const initPurchaseOrders = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/purchase-order`, config)
            .then((res) => {
                setPurchaseOrders(res.data.results || []);
                setLoadingOrders(false);
            })
            .catch((err) => {
                console.log(err);
                setLoadingOrders(false);
            });
    };

    const deletePurchaseOrder = (orderId: string) => {
        if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet ordre d\'achat ?')) {
            return;
        }
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .delete(`${CONFIG.apiUrl}/purchase-order/${orderId}`, config)
            .then((res) => {
                toast.success('Ordre d\'achat supprimé avec succès');
                initPurchaseOrders();
            })
            .catch((err) => {
                console.error('Error deleting purchase order:', err);
                const errorMessage = err.response?.data?.message || err.message || 'Erreur lors de la suppression';
                toast.error(errorMessage);
            });
    };

    useEffect(() => {
        initOffer();
        initUser();
        initPurchaseOrders();
        
        // Check for tab query parameter
        const urlParams = new URLSearchParams(window.location.search);
        const tabParam = urlParams.get('tab');
        if (tabParam === 'purchase-orders') {
            setActiveTab('purchase-orders');
        }
    }, []);

    useEffect(() => {
        if (!user) return;
        const urlParams = new URLSearchParams(window.location.search);
        const created = urlParams.get('created');
        const createdNotPaid = urlParams.get('not-paid');

        if (created === 'true' && !isOpen) {
            onOpen();
        }

        if (createdNotPaid === 'true' && !isOpen2) {
            onOpen2();
        }
    }, [user]);

    const Headline = () => {
        return (
            <Card
                extra={
                    'w-full pb-[10px] pt-[10px] px-[29px] h-fit shadow shadow-3xl rounded-[20px] border'
                }
            >
                {/* Header */}
                <div className="mt-1">
                    <p className="text-xl font-semibold text-navy-700 dark:text-white">
                        Mes commandes 🛒
                    </p>
                    <p className="mt-2 text-base text-gray-600">
                        Suivez l'évolution de vos commandes, gérez leur statut
                        et assurez-vous que tout se déroule correctement à
                        chaque étape.
                    </p>
                </div>
            </Card>
        );
    };

    return (
        <div>
            <ToastContainer />
            <SuccessModal isOpen={isOpen} onClose={onClose} />
            <ErrorModal isOpen={isOpen2} onClose={onClose2} />
            <div className="flex h-full w-full flex-col rounded-[20px] xl:flex-row ">
                <div className="h-full w-full rounded-[20px]">
                    {/* left side */}
                    <div className="col-span-9 h-full w-full rounded-t-2xl xl:col-span-6">
                        {/* Your Transfers & tables */}
                        <div className="grid w-full grid-cols-12 gap-2">
                            <div className="col-span-12">
                                <div className={'h-full w-full px-1'}>
                                    <Headline />
                                    
                                    {/* Tabs */}
                                    <Card extra="w-full mt-5 p-4">
                                        <div className="flex gap-4 border-b border-gray-200">
                                            <button
                                                onClick={() => setActiveTab('offers')}
                                                className={`pb-3 px-4 font-semibold transition-all ${
                                                    activeTab === 'offers'
                                                        ? 'border-b-2 border-leadrs text-leadrs'
                                                        : 'text-gray-500 hover:text-gray-700'
                                                }`}
                                            >
                                                Mes commandes
                                            </button>
                                            <button
                                                onClick={() => setActiveTab('purchase-orders')}
                                                className={`pb-3 px-4 font-semibold transition-all ${
                                                    activeTab === 'purchase-orders'
                                                        ? 'border-b-2 border-[#10b981] text-[#10b981]'
                                                        : 'text-gray-500 hover:text-gray-700'
                                                }`}
                                            >
                                                Mes ordres d'achat
                                            </button>
                                        </div>
                                    </Card>
                                    
                                    {/* Offers Tab Content */}
                                    {activeTab === 'offers' && (
                                        <>
                                    <div className="grid grid-cols-12">
                                        <div className="col-span-12 flex justify-between"></div>
                                    </div>
                                    {offer && offer.length === 0 && (
                                        <div className="mt-5 justify-center">
                                            <p className="flex justify-center text-xl text-gray-400">
                                                Vous n'avez pas encore passé
                                                commande
                                            </p>
                                            <button
                                                className="text-md mx-auto mt-5 flex rounded-xl bg-leadrs px-6 py-3 font-medium text-white transition duration-200 hover:bg-leadrsLight"
                                                onClick={() =>
                                                    nav('/admin/create-order')
                                                }
                                            >
                                                Passer ma première commande
                                            </button>
                                        </div>
                                    )}
                                    <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                                        {user &&
                                            user.role &&
                                            user.role !== 'paying-user' && (
                                                <Card
                                                    extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white border-2 border-leadrs border-dashed shadow-xl cursor-pointer`}
                                                >
                                                    <div className="mx-auto my-auto items-center text-center">
                                                        <h1 className="text-2xl font-bold text-leadrs">
                                                            Besoin de
                                                            <br></br>
                                                            nouveaux leads ?
                                                        </h1>
                                                        <button
                                                            className="mx-auto mt-4 flex rounded-2xl bg-leadrs px-5 py-3 text-xs font-bold text-white hover:bg-leadrsLight"
                                                            onClick={() =>
                                                                (window.location.href =
                                                                    '/admin/create-order')
                                                            }
                                                        >
                                                            Passez commande
                                                        </button>
                                                    </div>
                                                </Card>
                                            )}
                                        {offer.slice(0, 3).map((item) => (
                                            <BuyerMyOfferCard
                                                bidders={[
                                                    avatar1,
                                                    avatar2,
                                                    avatar3,
                                                ]}
                                                industry={item.industry}
                                                channels={item.channels}
                                                offerNumber={
                                                    item.offerBuyerNumber
                                                }
                                                subIndustry={item.subIndustry}
                                                targetPrice={item.targetPrice}
                                                weeklyQuantity={Number(
                                                    item.weeklyQuantity
                                                )}
                                                leadsGenerated={Number(
                                                    item.leadsGenerated
                                                )}
                                                otherIndustry={
                                                    item.otherIndustry
                                                }
                                                user={user}
                                                // status={
                                                //     user &&
                                                //     user.role === 'paying-user'
                                                //         ? item.status
                                                //         : 'not-paid'
                                                // }
                                                status={item.status}
                                                image={getImage(
                                                    item.industry,
                                                    item.subIndustry
                                                )}
                                                onClick={() => {
                                                    nav(
                                                        `/admin/my-offers/${item._id}`
                                                    );
                                                }}
                                            />
                                        ))}
                                        {user &&
                                            user.role &&
                                            user.role !== 'user' && (
                                                <Card
                                                    extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white border-2 border-leadrs border-dashed shadow-xl cursor-pointer`}
                                                >
                                                    <div className="mx-auto my-auto items-center text-center">
                                                        <h1 className="text-2xl font-bold text-leadrs">
                                                            Besoin de<br></br>
                                                            nouveaux leads ?
                                                        </h1>
                                                        <button
                                                            className="mx-auto mt-4 flex rounded-2xl bg-leadrs px-5 py-3 text-xs font-bold text-white hover:bg-leadrsLight"
                                                            onClick={() =>
                                                                (window.location.href =
                                                                    '/admin/create-order')
                                                            }
                                                        >
                                                            Passez commande
                                                        </button>
                                                    </div>
                                                </Card>
                                            )}
                                        {offer.slice(3).map((item) => (
                                            <BuyerMyOfferCard
                                                bidders={[
                                                    avatar1,
                                                    avatar2,
                                                    avatar3,
                                                ]}
                                                industry={item.industry}
                                                channels={item.channels}
                                                offerNumber={
                                                    item.offerBuyerNumber
                                                }
                                                subIndustry={item.subIndustry}
                                                targetPrice={item.targetPrice}
                                                weeklyQuantity={Number(
                                                    item.weeklyQuantity
                                                )}
                                                leadsGenerated={Number(
                                                    item.leadsGenerated
                                                )}
                                                otherIndustry={
                                                    item.otherIndustry
                                                }
                                                user={user}
                                                // status={
                                                //     user &&
                                                //     user.role === 'paying-user'
                                                //         ? item.status
                                                //         : 'not-paid'
                                                // }
                                                status={item.status}
                                                image={getImage(
                                                    item.industry,
                                                    item.subIndustry
                                                )}
                                                onClick={() => {
                                                    nav(
                                                        `/admin/my-offers/${item._id}`
                                                    );
                                                }}
                                            />
                                        ))}
                                    </div>
                                    </>
                                    )}
                                    
                                    {/* Purchase Orders Tab Content */}
                                    {activeTab === 'purchase-orders' && (
                                        <div className="mt-5">
                                            {loadingOrders ? (
                                                <div className="text-center py-8">
                                                    <p className="text-gray-600">Chargement...</p>
                                                </div>
                                            ) : purchaseOrders.length === 0 ? (
                                                <div className="mt-5 justify-center">
                                                    <p className="flex justify-center text-xl text-gray-400">
                                                        Vous n'avez pas encore d'ordre d'achat automatique
                                                    </p>
                                                    <button
                                                        className="text-md mx-auto mt-5 flex rounded-xl bg-leadrs px-6 py-3 font-medium text-white transition duration-200 hover:bg-leadrsLight"
                                                        onClick={() => nav('/admin/purchase-order')}
                                                    >
                                                        Créer mon premier ordre d'achat
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
                                                    <Card
                                                        extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white border-2 border-leadrs border-dashed shadow-xl cursor-pointer border-[#10b981]`}
                                                    >
                                                        <div className="mx-auto my-auto items-center text-center">
                                                            <h1 className="text-2xl font-bold text-[#10b981]">
                                                                Besoin de plus de leads ?
                                                            </h1>
                                                            <button
                                                                className="mx-auto mt-4 flex rounded-2xl bg-[#10b981] px-5 py-3 text-xs font-bold text-white hover:bg-[#34d399]"
                                                                onClick={() => nav('/admin/purchase-order')}
                                                                disabled={true}
                                                            >
                                                                Faire un ordre d'achat
                                                            </button>
                                                        </div>
                                                    </Card>
                                                    {purchaseOrders.map((order) => (
                                                        <Card
                                                            key={order._id}
                                                            extra="flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white border-2 hover:shadow-xl"
                                                        >
                                                            <div className="h-full w-full">
                                                                <div className="relative w-full">
                                                                    <img
                                                                        src={getImage(
                                                                            convertToProperCase(order.industry),
                                                                            convertToProperCase(order.product)
                                                                        )}
                                                                        className="mb-3 max-h-[130px] w-full rounded-xl 3xl:h-full 3xl:w-full"
                                                                        alt=""
                                                                    />
                                                                </div>

                                                                <div className="px-1">
                                                                    <p className="mt-1 text-sm font-medium text-gray-600">
                                                                        {convertToProperCase(order.product)}
                                                                    </p>
                                                                    <div className="flex gap-2">
                                                                        <p className="text-lg font-bold text-navy-700">
                                                                            {convertToProperCase(order.industry)}
                                                                        </p>
                                                                    </div>
                                                                    <p className='text-xs'>{order.departments.join(', ').length > 50 ? order.departments.join(', ').substring(0, 50) + '...' : order.departments.join(', ')}</p>
                                                                </div>

                                                                <div className="mt-3 grid w-full grid-cols-2 gap-2">
                                                                    <div>
                                                                        <p className="text-xs text-gray-600">Prix max</p>
                                                                        <p className="text-sm font-bold text-leadrs">
                                                                            {order?.maxPricePerLead?.toFixed(2)}€/lead
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p className="text-xs text-gray-600">Reçus</p>
                                                                        <p className="text-sm font-bold text-leadrs">
                                                                            {order.totalLeadsDelivered || 0}/{order.leadCount}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div className="relative pt-3">
                                                                    <div className="w-full rounded-full bg-gray-200">
                                                                        <div
                                                                            className="h-3 rounded-full bg-leadrs"
                                                                            style={{
                                                                                width: `${Math.min(
                                                                                    ((order.leadsReceived || 0) / order.leadCount) * 100,
                                                                                    100
                                                                                )}%`,
                                                                            }}
                                                                        ></div>
                                                                    </div>
                                                                </div>

                                                                <div className="mt-3 flex items-center justify-between">
                                                                    <span
                                                                        className={`inline-block rounded-full px-3 py-1 text-xs font-semibold ${
                                                                            order.status === 'active'
                                                                                ? 'bg-green-100 text-green-800'
                                                                                : order.status === 'paused'
                                                                                ? 'bg-yellow-100 text-yellow-800'
                                                                                : order.status === 'completed'
                                                                                ? 'bg-blue-100 text-blue-800'
                                                                                : 'bg-gray-100 text-gray-800'
                                                                        }`}
                                                                    >
                                                                        {order.status === 'active' && 'Actif'}
                                                                        {order.status === 'paused' && 'En pause'}
                                                                        {order.status === 'completed' && 'Terminé'}
                                                                        {order.status === 'cancelled' && 'Annulé'}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* <div className="col-span-12 sm:col-span-3">
              <OrderStatus offer={offer[0]} />
            </div> */}
                            {/* <div className="col-span-6 3xl:col-span-2">
              <YourCard />
            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyOffer;
